import styled from 'styled-components';
import { v2Colors, v2FontFamily } from './styles/tokens';

export const OptionList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 2px;
  font-family: ${v2FontFamily};

  &.row-layout {
    flex-direction: row;
    flex-wrap: wrap;
  }

  .option-card {
    position: relative;
    display: flex;
    align-items: center;
    gap: 10px;
    flex: 1 1 auto;
    min-height: 40px;
    padding: 9px 12px;
    background: ${v2Colors.inputBackground};
    border: 1.5px solid ${v2Colors.border};
    border-radius: 12px;
    cursor: pointer;
    transition: border-color 120ms ease, background-color 120ms ease;
  }

  &.row-layout .option-card {
    flex-basis: 140px;
  }

  .option-card input {
    position: absolute;
    width: 1px;
    height: 1px;
    margin: 0;
    opacity: 0;
    pointer-events: none;
  }

  .option-indicator {
    flex: 0 0 auto;
    width: 18px;
    height: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1.5px solid ${v2Colors.border};
    background: #fff;
    transition: border-color 120ms ease, background-color 120ms ease;
  }

  .option-card.shape-round .option-indicator {
    border-radius: 50%;
  }

  .option-card.shape-square .option-indicator {
    border-radius: 6px;
  }

  .option-indicator .dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: transparent;
    transition: background-color 120ms ease;
  }

  .option-indicator svg {
    width: 11px;
    height: 11px;
    opacity: 0;
    transition: opacity 120ms ease;
  }

  .option-label {
    font-size: 14.5px;
    font-weight: 400;
    color: ${v2Colors.text};
  }

  .option-card:hover {
    border-color: ${v2Colors.borderStrong};
  }

  .option-card:has(input:checked) {
    border-color: ${v2Colors.primary};
    background: ${v2Colors.primarySoft};
  }

  .option-card:has(input:checked) .option-indicator {
    border-color: ${v2Colors.primary};
    background: ${v2Colors.primary};
  }

  .option-card:has(input:checked) .option-indicator .dot {
    background: #fff;
  }

  .option-card:has(input:checked) .option-indicator svg {
    opacity: 1;
  }

  .option-card:has(input:focus-visible) {
    outline: 2px solid ${v2Colors.primary};
    outline-offset: 1px;
  }

  .option-card.is-disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  /* Error state: red border + soft red halo on every option, matching the
     .is-invalid style of the text/number/select fields. */
  &.is-invalid .option-card {
    border-color: ${v2Colors.danger};
    box-shadow: 0 0 0 3px rgba(217, 45, 32, 0.12);
  }

  &.is-invalid .option-card:hover {
    border-color: ${v2Colors.danger};
  }

  @media (max-width: 480px) {
    &.row-layout .option-card {
      flex-basis: 45%;
    }
  }
`;
